import { MutationCache, QueryClient } from "@tanstack/react-query";

// After any successful mutation, refetch active queries. This keeps the UI in
// sync without per-component invalidation wiring (similar to SWR's automatic
// revalidation). Mutations that need bespoke cache handling can still pass their
// own onSuccess.
export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onSuccess: () => {
      queryClient.invalidateQueries();
    },
  }),
  defaultOptions: {
    queries: {
      retry: 2,
      retryDelay: (attempt) => Math.min(1_000 * 2 ** attempt, 10_000), // 1s, 2s, 4s, 8s, 10s
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
    },
  },
});
